import React from 'react';
import { FeatureContainer, FeatureButton } from './FeatureElements';

const Feature = () => {
	return (

	<FeatureContainer>
		<h1>Beliebteste Pizza</h1>
		<p>Beschreibung Beschreibung Beschreibung Beschreibung </p>
		<FeatureButton>Jetzt bestellen</FeatureButton>
	</FeatureContainer>
);
};

export default Feature;